import { fetch, getIdOrNull } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const createStudentFreeField = (user, studentFreeField) => {
  return fetch(
    '/api/free-fields',
    HttpMethods.POST,
    studentFreeField,
    user
  )
}

export const updateStudentFreeField = (user, studentFreeField) => {
  return fetch(
    `/api/free-fields/${getIdOrNull(studentFreeField)}`,
    HttpMethods.PATCH,
    studentFreeField,
    user
  )
}

export const deleteStudentFreeFields = (user, studentFreeField) => {
  return fetch(
    `/api/studentFreeFields/${getIdOrNull(studentFreeField)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const getStudentFreeFields = (user, students) => apiClient.get(user, 'free-fields/students', { students: students })
export const getFreeFields = (user, parameters) => apiClient.get(user, 'free-fields/all', parameters)
